module.exports = __webpack_public_path__ + "components/country-flag/static/ac-459db95a5d47c5f96875affdf806dc07.svg";